/**
 * Job priority options and helpers.
 * Mapping: 1=EMG P4, 2=P7, 3=P24, 4=P48
 */

export const PRIORITY_OPTIONS = [
  { value: 1, label: 'EMG P4' },
  { value: 3, label: 'P24' },
  { value: 4, label: 'P48' },
  { value: 2, label: 'P7' },
];

/**
 * @param {number} priorityId - Stored priority value (1-4)
 * @returns {string} Display label; falls back to 'P7' for invalid/missing
 */
export function getPriorityLabel(priorityId) {
  const p = Number(priorityId);
  if (p === 1) return 'EMG P4';
  if (p === 2) return 'P7';
  if (p === 3) return 'P24';
  if (p === 4) return 'P48';
  return 'P7';
}
